<!-- Modal Container -->
<div class="relative z-20" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop with blur -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity"
       (click)="onBackdropClick()"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!-- Modal panel -->
      <div class="relative transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl"
           (click)="$event.stopPropagation()">

        <!-- Close button -->
        <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
          <button type="button"
                  (click)="closeModal()"
                  [disabled]="busy"
                  class="rounded-md bg-white dark:bg-gray-800 text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 focus:outline-none focus:ring-none disabled:opacity-50 disabled:cursor-not-allowed">
            <span class="sr-only">Close</span>
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Modal Header -->
        <div class="px-4 py-4 lg:px-6 lg:py-4">
          <h3 class="text-2xl font-semibold text-gray-900 dark:text-white" id="modal-title">
            Edit Workspace <span class="text-purple-600">{{ workspaceData.name }}</span>
          </h3>
        </div>

        <!-- Modal Body -->
        <div class="px-4 lg:px-6 overflow-y-auto max-h-[calc(100vh-280px)]">
          <form (ngSubmit)="saveWorkspace()">
            <!-- Workspace Name -->
            <div class="mb-6">
              <label for="workspace-name" class="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-300 mb-2">
                Workspace Name<span class="text-red-500 ml-1">*</span>
              </label>
              <input type="text"
                     id="workspace-name"
                     [(ngModel)]="workspaceData.name"
                     name="workspaceName"
                     class="block w-full rounded-md border-0 py-2.5 px-3 text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 dark:bg-gray-700 sm:text-sm sm:leading-6 disabled:bg-gray-100 disabled:dark:bg-gray-800 disabled:text-gray-500 disabled:cursor-not-allowed"
                     [disabled]="workspace?.is_default"
                     required>
            </div>

            <!-- Description -->
            <div class="mb-6">
              <label for="description" class="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-300 mb-1">
                Description
              </label>
              <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">Add a description of your new workspace</p>
              <textarea id="description"
                        [(ngModel)]="workspaceData.description"
                        name="description"
                        rows="4"
                        class="block w-full rounded-md border-0 py-2.5 px-3 text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 dark:bg-gray-700 sm:text-sm sm:leading-6 resize-none disabled:bg-gray-100 disabled:dark:bg-gray-800 disabled:text-gray-500 disabled:cursor-not-allowed"
                        placeholder="Lorem ipsum dolor sit amet..."></textarea>
            </div>

            <!-- Instructions -->
            <div class="mb-6">
              <label for="instructions" class="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-300 mb-1">
                Instructions
              </label>
              <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">Add instructions for your new workspace</p>
              <textarea id="instructions"
                        [(ngModel)]="workspaceData.instructions"
                        name="instructions"
                        rows="4"
                        class="block w-full rounded-md border-0 py-2.5 px-3 text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 dark:bg-gray-700 sm:text-sm sm:leading-6 resize-none disabled:bg-gray-100 disabled:dark:bg-gray-800 disabled:text-gray-500 disabled:cursor-not-allowed"
                        placeholder="Lorem ipsum dolor sit amet..."></textarea>
            </div>

            <!-- Knowledge Base -->
            <div class="mb-6">
              <label class="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-300 mb-1">
                Knowledge base
              </label>
              <p class="text-sm text-gray-500 dark:text-gray-400 mb-3">Upload files containing information about your project</p>

              <!-- Loading state for files -->
              <div *ngIf="loadingFiles" class="flex justify-center py-4 mb-4">
                <svg class="animate-spin h-6 w-6 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>

              <!-- Existing Files Grid -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4" *ngIf="!loadingFiles && workspaceData.files && workspaceData.files.length > 0">
                <div *ngFor="let file of workspaceData.files"
                     class="group flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                  <div class="flex items-center gap-3 min-w-0">
                    <!-- File Icon -->
                    <div class="flex-shrink-0">
                      <div class="w-10 h-10 bg-white dark:bg-gray-600 rounded-lg flex items-center justify-center">
                        <svg *ngIf="getFileType(file) === 'pdf'" class="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                          <text x="12" y="18" text-anchor="middle" font-family="Arial, sans-serif" font-size="6" font-weight="700" fill="currentColor">PDF</text>
                        </svg>
                        <svg *ngIf="getFileType(file) === 'xlsx'" class="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20M12.9,14.5L15.8,19H14L12,15.6L10,19H8.2L11.1,14.5L8.2,10H10L12,13.4L14,10H15.8L12.9,14.5Z"/>
                        </svg>
                        <svg *ngIf="getFileType(file) === 'pptx'" class="w-6 h-6 text-orange-600" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M13,3.5V9H18.5L13,3.5M8,11V13H9V19H8V20H12V19H11V17H13A3,3 0 0,0 16,14A3,3 0 0,0 13,11H8M13,13A1,1 0 0,1 14,14A1,1 0 0,1 13,15H11V13H13Z"/>
                        </svg>
                        <svg *ngIf="getFileType(file) === 'image'" class="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M21,3H3C2,3 1,4 1,5V19A2,2 0 0,0 3,21H21C22,21 23,20 23,19V5C23,4 22,3 21,3M5,17L8.5,12.5L11,15.5L14.5,11L19,17H5Z"/>
                        </svg>
                        <svg *ngIf="getFileType(file) === 'document'" class="w-6 h-6 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20M13,3.5L18.5,9H13V3.5Z"/>
                        </svg>
                      </div>
                    </div>
                    <!-- File Info -->
                    <div class="min-w-0 flex-1">
                      <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ file.original_filename }}</p>
                      <p class="text-xs text-gray-500 dark:text-gray-400">{{ file.formatted_file_size }} • Updated {{ getFileUpdatedAt(file) }}</p>
                    </div>
                  </div>
                  <!-- Delete Button -->
                  <button type="button"
                          (click)="removeFile(file)"
                          title="Delete file"
                          class="flex-shrink-0 p-2 rounded-lg text-gray-500 dark:text-gray-400 opacity-0 group-hover:opacity-100 focus-visible:opacity-100 transition hover:bg-gray-200 dark:hover:bg-gray-600">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Upload Area -->
              <div class="border-2 border-dashed rounded-lg p-8 text-center transition-colors"
                   [ngClass]="(atLimit || loadingFiles)
                     ? 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40 opacity-60'
                     : 'border-gray-300 dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500'">
                <input type="file"
                       id="file-upload-modal"
                       (change)="onFileSelected($event)"
                       class="hidden"
                       accept=".pdf,.doc,.docx,.txt,.csv,.xlsx,.pptx"
                       [disabled]="uploadingFile || atLimit || loadingFiles">

                <label for="file-upload-modal"
                       [class.cursor-pointer]="!atLimit && !uploadingFile && !loadingFiles"
                       [class.cursor-not-allowed]="atLimit || uploadingFile || loadingFiles">
                  <svg *ngIf="!uploadingFile" class="mx-auto h-6 w-6 text-gray-400 dark:text-gray-500 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                  </svg>
                  <svg *ngIf="uploadingFile" class="animate-spin h-6 w-6 mx-auto mb-3 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span class="font-medium text-sm tracking-wide"
                        [class.text-blue-600]="!atLimit && !loadingFiles"
                        [class.dark:text-blue-400]="!atLimit && !loadingFiles"
                        [class.text-gray-500]="atLimit || loadingFiles"
                        [class.dark:text-gray-400]="atLimit || loadingFiles">
                    {{ uploadingFile ? 'Uploading...' : (loadingFiles ? 'Loading files…' : (atLimit ? 'Workspace full' : 'Upload file')) }}
                  </span>
                  <p class="text-xs text-gray-500 dark:text-gray-400 tracking-wide mt-1">
                    {{ loadingFiles
                       ? 'Checking remaining storage…'
                       : (atLimit ? 'Delete a file to free up space (10 MB workspace limit).' : availableSizeLabel + ' of 10 MB') }}
                  </p>
                </label>
              </div>

            </div>
          </form>
        </div>

        <!-- Modal Footer -->
        <div class="bg-gray-50 dark:bg-gray-900 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <div class="flex w-full sm:w-auto">
            <button type="button"
                    (click)="saveWorkspace()"
                    [disabled]="busy || !workspaceData.name?.trim()"
                    class="inline-flex w-full justify-center items-center gap-2 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed sm:ml-3 sm:w-auto">
              <svg *ngIf="saving" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ saving ? 'Saving...' : (workspace?.is_default ? 'Update Workspace' : 'Save Workspace') }}
            </button>
            <button type="button"
                    (click)="closeModal()"
                    [disabled]="busy"
                    class="mt-3 sm:mt-0 sm:ml-3 inline-flex w-full justify-center rounded-md bg-white dark:bg-gray-800 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-300 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed sm:w-auto">
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete File Confirmation Modal -->
<app-delete-workspace-modal
  *ngIf="deleteFileState.show"
  [fileName]="deleteFileState.file?.original_filename || ''"
  [isDeleting]="deleteFileState.isDeleting"
  (confirmDelete)="confirmDeleteFile()"
  (cancelDelete)="cancelDeleteFile()"
></app-delete-workspace-modal>
